export type ContextRecord = Record<string, string | number | boolean>

export function toContextTuplesString(context: ContextRecord): string {
  return Object.entries(context)
    .map(([key, value]) => `${key}=${value}`)
    .join(', ')
}

export function toErrorOrStringify(e: unknown): Error | string {
  if (e instanceof Error || typeof e === 'string') {
    return e
  }

  try {
    return JSON.stringify(e)
  } catch {
    return String(e)
  }
}
